import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='income-annuities-faq'
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          <Typography component='span'>
            Questions about annuities&#63;
          </Typography>
          <Typography
            component='span'
            block>
            We&#39;ve got answers.
          </Typography>
        </Typography>
      </Col>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='faq-income-annuities'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'income-annuities-what-is-it',
              title: <>What is <WidowBlock>an annuity&#63;</WidowBlock></>,
              content: (
                <Typography component='span' disableBottomPadding>
                  There are a few different types of annuities. Income annuities give you a guaranteed, steady stream of income in retirement that will last the rest of your life. Fixed and variable annuities can help you grow your savings for retirement.{' '}
                  <Link
                    id='income-annuities-what-is-it-link'
                    variant='primaryDeemphasize'
                    linkUrl='/life-and-money/how-do-annuities-work/'>
                    Find out more about how annuities work
                  </Link>.
                </Typography>
              ),
            },
            {
              id:'income-annuities-why-do-i-need-it',
              title: <>Who are <WidowBlock>annuities for&#63;</WidowBlock></>,
              content: (
                <Typography
                  component='span'
                  disableBottomPadding>
                  Annuities could be a great option for anyone who wants to plan ahead for the money they&#39;ll need in retirement. To find out how an annuity fits into your financial plan,{' '}
                  <Link
                    id='income-annuities-why-do-i-need-it'
                    linkUrl='/find-a-financial-advisor/'
                    variant='primaryDeemphasize'>
                    connect with an advisor
                  </Link>.
                </Typography>
              ),
            },
            {
              id: 'income-annuities-work-coverage',
              title: <>Is an annuity a good idea <WidowBlock>for retirement&#63;</WidowBlock></>,
              content: (
                <>
                  <Typography
                    component='span'
                    nextElement='typography'
                    block>
                    Annuities can play a key part in building a strong{' '}
                    <Link
                      id='income-annuities-work-coverage-retirement-link'
                      linkUrl='/retirement-planning/'
                      variant='primaryDeemphasize'
                      ariaLabel='Learn more about retirement planning'>
                      retirement plan
                    </Link>
                    . Essentially, an annuity is a way for you to recreate your work paycheck, which can be helpful if you&#39;re worried about outliving your savings. This guaranteed income can help you cover essential expenses, maintain your lifestyle, and most important, help you feel financially secure when you retire. Unlike other investment options, annuities will give you a steady stream of income even with swings in the market. Annuities also offer tax advantages as any growth is tax&#45;deferred until withdrawals are made.
                  </Typography>
                  <Typography
                    component='span'
                    disableBottomPadding>
                    Find out how an annuity can help you retire the way you want.{' '}
                    <Link
                      id='income-annuities-work-coverage-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Get matched with an advisor
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'income-annuities-what-is-income',
              title: <>What is <WidowBlock>annuity income&#63;</WidowBlock></>,
              content: (
                <Typography
                  component='span'
                  disableBottomPadding>
                  Annuity income refers to the payments you get from your annuity in retirement. Depending on the kind of annuity you own, it can be taken annually, semi&#45;annually, quarterly, or monthly. Your financial advisor can help you decide what payment structure would work best for your goals.{' '}
                  <Link
                    id='income-annuities-what-is-income-fafa-link'
                    linkUrl='/find-a-financial-advisor/'
                    variant='primaryDeemphasize'
                    ariaLabel='Connect with a Northwestern Mutual financial advisor today'>
                    Connect with an advisor
                  </Link>.
                </Typography>
              ),
            },
            {
              id: 'income-annuities-social-security',
              title: <>What&#39;s the best age to buy <WidowBlock>an annuity&#63;</WidowBlock></>,
              content: (
                <Typography
                  component='span'
                  disableBottomPadding>
                  An immediate income annuity&#39;s name somewhat defines it&#8212;it&#39;s intended for someone who is near retirement because payments begin within a year of purchase. Other annuities are best purchased throughout your working years, based on your life and goals. The right time to buy an annuity is different for everyone. Your Northwestern Mutual financial advisor can help you decide what type of annuity is the smartest option for your plan.{' '}
                  <Link
                    id='income-annuities-social-security-link'
                    linkUrl='/find-a-financial-advisor/'
                    variant='primaryDeemphasize'
                    ariaLabel='Connect with a Northwestern Mutual financial advisor'>
                    Connect with an advisor
                  </Link>.
                </Typography>
              ),
            },
            {
              id: 'income-annuities-is-it-an-investment',
              title: <>What other kinds of annuities <WidowBlock>are there&#63;</WidowBlock></>,
              content: (
                <Typography
                  component='span'
                  disableBottomPadding>
                  In addition to income annuities, there are also{' '}
                  <Link
                    id='income-annuities-is-it-an-investment-fixed-variable-annuities-link'
                    linkUrl='/investments/fixed-annuity-vs-variable-annuity/'
                    variant='primaryDeemphasize'>
                    fixed and variable annuities
                  </Link>
                  . These can help you save for retirement and grow your money over time. Then when you get to retirement, you&#39;ll have the option to take your account value in one lump sum or convert it to a guaranteed stream of income. Want to know more&#63; Get our guide on{' '}
                  <Link
                    id='income-annuities-is-it-an-investment-type-of-annuities-link'
                    linkUrl='/life-and-money/what-are-the-different-types-of-annuities/'
                    variant='primaryDeemphasize'>
                    types of annuities
                  </Link>.
                </Typography>
              ),
            },
            {
              id: 'income-annuities-differences',
              title: <>What&#39;s the difference between fixed, variable, and <WidowBlock>income annuities&#63;</WidowBlock></>,
              content: (
                <>
                  <Typography
                    component='span'
                    nextElement='typography'
                    block>
                    While all three are annuities, each solution is distinct from each other. Fixed annuities give you safe and steady interest income at a set rate for a set amount of time that is not affected by market fluctuations. On the other hand, variable annuities give you the opportunity for growth by letting you invest your money in assets like mutual funds or stocks. While it has the potential for higher returns, a variable annuity also has higher risk due to market fluctuations. With an income annuity, you make a lump&#45;sum payment and in return you get a guaranteed, steady stream of income that you can&#39;t outlive.
                  </Typography>
                  <Typography
                    component='span'
                    disableBottomPadding>
                    Want to learn more&#63; See{' '}
                    <Link
                      id='income-annuities-differences-how-do-they-work-link'
                      linkUrl='/life-and-money/how-do-variable-annuities-work/'
                      variant='primaryDeemphasize'>
                      how variable annuities work
                    </Link>
                    {' '}or{' '}
                    <Link
                      id='income-annuities-differences-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      connect with an advisor
                    </Link>.
                  </Typography>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
